module.exports = __webpack_public_path__ + "f5d269ce47d1a1c1f02ad039173db157.png";